import { __awaiter, __generator } from "tslib";
import { initialize } from './i18n-initialize';
import { Fetch } from '@ekuaibao/fetch';
import { initFeatBit } from "../lib/featbit";
export function newHomeConfig() {
    return __awaiter(this, void 0, void 0, function () {
        var defaultPreviewURL, value, error_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    window.isNewHome = true;
                    defaultPreviewURL = 'https://doc.ekuaibao.com';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, Fetch.GET(location.origin + "/api/previewUrl")];
                case 2:
                    value = (_b.sent()).value;
                    window.PREVIEW_DOMAIN = value || defaultPreviewURL;
                    return [3, 4];
                case 3:
                    error_1 = _b.sent();
                    window.PREVIEW_DOMAIN = defaultPreviewURL;
                    return [3, 4];
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4, initFeatBit()];
                case 5:
                    _b.sent();
                    return [3, 7];
                case 6:
                    _a = _b.sent();
                    return [3, 7];
                case 7:
                    if (IS_HSFK)
                        return [2, Promise.resolve()];
                    return [2, initialize()];
            }
        });
    });
}
